import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTotalDeposit,
  setButtonEnabled,
  setTotalAmount,
} from "../../../main/slices/transactionSlice";
import { Delete, BackspaceRounded } from '@mui/icons-material';

export const Keypad = ({ typeOperation = "", maxDecimales = 10, onCharge, children  }) => {
  const [amount, setAmount] = useState(0); // monto en número
  const stateTrx = useSelector(({ transaction }) => transaction);
  const stateStore = useSelector(({ store }) => store);
  const dispatch = useDispatch();

  const maxValue = 99999.99; // Límite máximo

  //---> Formato moneda;
  const FormatoMoneda = (numero, moneda = "GTQ", minDec = 0, maxDec = 18) => {
    if (isNaN(numero)) numero = 0;
    let Formato = new Intl.NumberFormat("en-EN", {
      minimumFractionDigits: minDec,
      maximumFractionDigits: maxDec,
    }).format(numero);
    return `${Formato} ${moneda}`;
  };

  const calculateTotal = (currentAmount) => {
    // Se multiplica el valor 1.005 para que la tasa de cambio de la worldapp y la de la cotización sean similares
    const cobrar = (currentAmount * 1.005) / stateTrx.fiatRecibe.value
    if (!currentAmount) return 0;
    return (
      cobrar
    );
  };

  const handleKeyPress = (value) => {
    let newAmount = amount;

    if (value === "clear") {
      newAmount = 0.00;
    } else if (value === "backspace") {
      // Retroceso: elimina último dígito en centavos
      const cents = Math.floor(newAmount * 100);
      const newCents = Math.floor(cents / 10);
      newAmount = newCents / 100;
    } else if (value === "Cobrar") {
      if (onCharge) onCharge(amount);
      return;
    } else if (/^[0-9]$/.test(value)) {
      const cents = Math.round(newAmount * 100);
      const newCents = cents * 10 + parseInt(value);
      const updated = newCents / 100;
      if (updated <= maxValue) newAmount = updated;
    }

    setAmount(newAmount);

    // Calcular total convertido
    let total = calculateTotal(newAmount);
    if (typeOperation === "cash") {
      total = Math.floor(parseFloat(total.toFixed(2)));
    }

    // Actualizar Redux
    dispatch(setTotalAmount({ value: newAmount, error: false }));
    dispatch(
      setTotalDeposit({ value: parseFloat(total.toFixed(2)), error: false })
    );
    dispatch(setButtonEnabled(newAmount > 0));
  };

  // Actualiza si cambian tasas
  useEffect(() => {
    if (amount) {
      let total = calculateTotal(amount);
      if (typeOperation === "cash") {
        total = Math.floor(parseFloat(total.toFixed(2)));
      }
      dispatch(
        setTotalDeposit({ value: parseFloat(total.toFixed(2)), error: false })
      );
    }
  }, [amount, stateTrx.rateCrypto.value]);

  const keys = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: <Delete fontSize="20px" />, value: "clear" },
    { label: "0", value: "0" },
    { label: <BackspaceRounded/>, value: "backspace" }
  ];

  return (
    <div>
      <style>
        {`
          .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 500px;
            width: 20rem;
            margin: 0 auto;
            padding: 1rem;
            margin-top: 5rem;
          }

          /* Panel superior */
          .amountDisplay {
            background-color: #eceff1;
            border-radius: 0.75rem;
            padding: 1rem 1.5rem;
            font-size: 2rem;
            width: 20rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
          }

          .amountRow {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .currency {
            font-weight: bold;
            color: rgba(108, 133, 137, 1);
            font-size: 2rem;
          }

          .amount {
            font-weight: bold;
            font-size: 1.8rem;
            color: #2F4A4E; /* verde */
          }

          /* Teclado */
          .keypad {
            width: 20rem;
            background-color: #eceff1;
            border-radius: 1rem;
            margin-top: 1rem;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.75rem;
            padding: 1rem;
            box-sizing: border-box;
          }

          .key {
            background-color: transparent;
            border: none;
            color: rgba(108, 133, 137, 1);
            font-size: 2rem;
            font-weight: 600;
            border-radius: 0.75rem;
            padding: 0.75rem;
            height: 60px;
            transition: background-color 0.2s;
          }

          .key:hover {
            background-color: #ede9fe; /* hover suave morado */
          }

          .keyClear {
            color: #ef4444; /* rojo */
            font-weight: bold;
            font-size: 1rem;
          }

          .keyCharge {
            color: #99b83c; /* verde */
            font-weight: bold;
            font-size: 1rem;
          }

          .bottomRow {
            grid-column: span 3;
            display: flex;
            justify-content: center;
            margin-top: 0.5rem;
          }
        `}
      </style>

      <div className="container">
        <div className="amountDisplay">
          <div className="amountRow">
            <span className="currency">{stateStore.currency.value}</span>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "0.9rem", color: "#2F4A4E" }}>Monto total</div>
              <div className="amount">{FormatoMoneda(amount, "", 2, 2)}</div>
            </div>
          </div>
        </div>

        <div className="keypad">
          {keys.map(({ label, value }) => (
            <button
              key={value}
              className="key"
              onClick={() => handleKeyPress(value)}
            >
              {label}
            </button>
          ))}

          <div className="bottomRow">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
